module.exports = __webpack_public_path__ + "static/media/app-store-badge.en.2928664f.svg";